import { render, staticRenderFns } from "./ControlEvaluaciones.vue?vue&type=template&id=5892daa6"
import script from "./ControlEvaluaciones.vue?vue&type=script&lang=js"
export * from "./ControlEvaluaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports